import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Product } from '../../../models/product.model';

@Component({
  selector: 'app-brief-product-info',
  templateUrl: './brief-product-info.component.html',
  styleUrls: ['./brief-product-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BriefProductInfoComponent implements OnInit {
  @Input() product: Product;

  constructor() {}

  ngOnInit(): void {}

  get imageUrl(): string {
    return this.product.thumbnail;
  }
}
